module.exports = __webpack_public_path__ + "img/ios-store.3bc25da5.png";